// Core version + modules:
import Swiper from 'swiper';
import { EffectFade, Navigation } from 'swiper/modules';
// Import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';

const container = document.querySelectorAll('.swiper.custom-case');

if (container) {
  container.forEach((element) => {
    const slidesPerViewDesktop = element.dataset.slidesDesktop ?? 1;
    const toggleFade = element.dataset.fade ?? false;
    initSwiper(element, slidesPerViewDesktop, toggleFade);
  });
}

function initSwiper(container, slidesPerViewDesktop, toggleFade) {

  let customBreakpoints = {
    0: {
      slidesPerView: 1
    }
  };

  let customFade = {};

  if (toggleFade) {
    customFade = {
      effect: "fade",
      fadeEffect: {
        crossFade: true
      }
    };
  }

  if (slidesPerViewDesktop > 1) {
    customBreakpoints = {
      0: {
        slidesPerView: 1
      },
      750: {
        slidesPerView: 2
      },
      990: {
        slidesPerView: slidesPerViewDesktop
      }
    };
  }

  // init Swiper:
  const swiper = new Swiper(container, {
    // configure Swiper to use modules
    modules: [EffectFade, Navigation],
    ...customFade,
    init: false,
    speed: 500,
    navigation: {
      nextEl: container.querySelector(".swiper-button-next"),
      prevEl: container.querySelector(".swiper-button-prev"),
    },
    breakpoints: customBreakpoints
  });

  swiper.init();
}